module.exports = "/_next/static/images/logo_senat_energie-11c73e4a833f42e2a30074fcd8ceeed0.svg";